import { jsxs, jsx } from 'react/jsx-runtime';
import { Field, Select, Textarea, Input } from '@headlessui/react';
import { clsx } from 'clsx';
import { useRef, useCallback, useEffect } from 'react';
import { useFormState } from 'react-hook-form';
import { useName } from '../utils/useName.js';
import { useFormField } from '../utils/useFormField.js';
import baseStyles from './InputBase.module.css.js';
import { InputBaseDescription } from './InputBaseDescription.js';
import { InputBaseLabel } from './InputBaseLabel.js';

function InputBase({ name: providedName, label, placeholder, description, rules, value, defaultValue, maxLength, disabled, onChange, type = "text", size = "base", autoComplete = "off", textFormatter, children, }) {
    const name = useName(providedName);
    const { register, setValue, formState: { errors }, control, } = useFormField();
    const touchedFields = useFormState({ name, control }).touchedFields;
    const previousValue = useRef(value);
    const handleChange = useCallback((event) => {
        if (value !== event.target.value) {
            const formattedValue = textFormatter ?
                textFormatter(event.target.value)
                : event.target.value;
            if (formattedValue !== event.target.value) {
                setValue(name, formattedValue, touchedFields[name] ? { shouldValidate: true } : undefined);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(formattedValue);
        }
    }, [name, onChange, setValue, value, textFormatter, touchedFields]);
    useEffect(() => {
        if (value !== undefined && value !== previousValue.current) {
            previousValue.current = value;
            setValue(name, value);
        }
    }, [name, setValue, value]);
    const error = errors[name];
    return (jsxs(Field, { disabled: disabled, children: [jsx(InputBaseLabel, { label: label, required: Boolean(rules === null || rules === void 0 ? void 0 : rules.required) }), type === "select" && (jsx(Select, Object.assign({}, register(name, Object.assign(Object.assign({}, rules), { onChange: handleChange })), { className: clsx(baseStyles.Input, {
                    [baseStyles.error]: Boolean(error),
                    [baseStyles.small]: size === "small",
                    [baseStyles.base]: size === "base",
                }), name: name, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : value, children: children }))), type === "textarea" && (jsx(Textarea, Object.assign({}, register(name, Object.assign(Object.assign({}, rules), { onChange: handleChange })), { className: clsx(baseStyles.Input, {
                    [baseStyles.error]: Boolean(error),
                    [baseStyles.small]: size === "small",
                    [baseStyles.base]: size === "base",
                }), name: name, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : value, placeholder: placeholder, maxLength: maxLength }))), type !== "select" && type !== "textarea" && (jsx(Input, Object.assign({}, register(name, Object.assign(Object.assign({}, rules), { onChange: handleChange })), { className: clsx(baseStyles.Input, {
                    [baseStyles.error]: Boolean(error),
                    [baseStyles.small]: size === "small",
                    [baseStyles.base]: size === "base",
                }), name: name, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : value, type: type, placeholder: placeholder, maxLength: maxLength, autoComplete: autoComplete }))), jsx(InputBaseDescription, { description: description, error: error })] }));
}

export { InputBase };
//# sourceMappingURL=InputBase.js.map
